import { Html5Qrcode } from "html5-qrcode";
import React, { useState, useEffect, useContext } from "react";
import "./qrScaner.css";
import ScanDataContext from "../ScanDataContext";
import { useNavigate } from "react-router-dom";

function QrScaner() {
  const [isEnabled, setEnabled] = useState(true);
  const [qrMessage, setQrMessage] = useState("");
  const { scanData, setScanData } = useContext(ScanDataContext);
  const navigate = useNavigate();
  useEffect(() => {
    const config = { fps: 10, qrbox: { width: 200, height: 200 } };

    const html5QrCode = new Html5Qrcode("qrCodeContainer");

    const qrScanerStop = () => {
      if (html5QrCode && html5QrCode.isScanning) {
        html5QrCode
          .stop()
          .then((ignore) => console.log("Scaner stop"))
          .catch((err) => console.log("Scaner error"));
      }
    };

    const qrCodeSuccess = (decodedText) => {
  const urlParts = decodedText.split('/');
  const campus = urlParts[3];
  const corpus = urlParts[4];
  const room = urlParts[5];
  setScanData(prevData => ({ ...prevData, campus, corpus, room, scanTime: new Date() }));

  setQrMessage(decodedText);
 
  setEnabled(false);

};
    

    if (isEnabled) {
        html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccess);
        setQrMessage("");
      } else {
        
        qrScanerStop();
      }      

    return () => {
      qrScanerStop();
    };
  }, [isEnabled]);

  return (
    <div className="scaner">
      <div id="qrCodeContainer" />
      
    </div>
  );  
}

export default QrScaner;
